export default __webpack_public_path__ + "img/tremors/tremors1_1500.jpg";